import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '@/assets/images/message.png'
import _imports_1 from '@/assets/images/message@2x.png'


const _hoisted_1 = _imports_1 + ' 2x'
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = { class: "right" }
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_radio = _resolveComponent("van-radio")!
  const _component_van_radio_group = _resolveComponent("van-radio-group")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_uploader = _resolveComponent("van-uploader")!
  const _component_van_action_sheet = _resolveComponent("van-action-sheet")!
  const _component_layout = _resolveComponent("layout")!

  return (_openBlock(), _createBlock(_component_layout, {
    onHandleNext: _ctx.handleNext,
    isDisabled: _ctx.isDisabled,
    current: 3,
    form: _ctx.form,
    btnText: "通知收款，提交申请",
    prePathName: "transfer"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _cache[10] || (_cache[10] = _createElementVNode("img", {
          src: _imports_0,
          srcset: _hoisted_1,
          alt: ""
        }, null, -1)),
        _createElementVNode("div", _hoisted_3, [
          _cache[9] || (_cache[9] = _createElementVNode("div", null, [
            _createTextVNode("上传转账凭证 "),
            _createElementVNode("span", null, "3/3")
          ], -1)),
          _createElementVNode("div", null, [
            _cache[6] || (_cache[6] = _createTextVNode(" 默认您使用")),
            _createElementVNode("span", null, _toDisplayString(_ctx.bankName), 1),
            _cache[7] || (_cache[7] = _createTextVNode("卡号")),
            _createElementVNode("span", null, _toDisplayString(_ctx.bankCardConvertFunc), 1),
            _cache[8] || (_cache[8] = _createTextVNode("进行转账 "))
          ])
        ])
      ]),
      _cache[13] || (_cache[13] = _createElementVNode("div", { class: "money-type" }, "转账币种", -1)),
      _createVNode(_component_van_field, {
        name: "noticeMoneyType",
        rules: [{ required: true, message: '请选择转账币种' }]
      }, {
        input: _withCtx(() => [
          _createVNode(_component_van_radio_group, {
            modelValue: _ctx.form.noticeMoneyType,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.noticeMoneyType) = $event)),
            direction: "horizontal"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.moneyOptions, (item, index) => {
                return (_openBlock(), _createBlock(_component_van_radio, {
                  key: index,
                  name: item.value
                }, {
                  icon: _withCtx(() => [
                    _createElementVNode("i", {
                      class: "iconfont icon-xuanze1",
                      style: _normalizeStyle({ color: _ctx.form.noticeMoneyType == item.value ? '#A79A28' : '#A5B2DC' })
                    }, null, 4)
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" " + _toDisplayString(item.name), 1)
                  ]),
                  _: 2
                }, 1032, ["name"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_van_cell_group, {
        title: "转入金额",
        border: false
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_field, {
            type: "digit",
            name: "money",
            modelValue: _ctx.form.noticeBalance,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.noticeBalance) = $event)),
            placeholder: "请输入金额",
            rules: [{ required: true, message: '请输入金额' }]
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _cache[14] || (_cache[14] = _createElementVNode("div", { class: "proof" }, "上传凭证", -1)),
      _createElementVNode("div", null, [
        _createVNode(_component_van_field, {
          name: "noticeMoneyType",
          rules: [{ required: true, message: '请上传凭证' }]
        }, {
          input: _withCtx(() => [
            _createVNode(_component_van_uploader, {
              modelValue: _ctx.fileList,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.fileList) = $event)),
              "before-read": _ctx.beforeRead,
              accept: ".pdf,image/*",
              "max-count": "5",
              "preview-size": "86",
              readonly: _ctx.isApp,
              deletable: false
            }, {
              "preview-cover": _withCtx((file) => [
                _createElementVNode("div", {
                  class: "preview-cover",
                  onClick: _withModifiers(($event: any) => (_ctx.handleDel(file)), ["stop"])
                }, _cache[11] || (_cache[11] = [
                  _createElementVNode("i", { class: "iconfont icon-cangpeitubiao_shanchu" }, null, -1)
                ]), 8, _hoisted_4)
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "upload-style",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.uploadToApp && _ctx.uploadToApp(...args)))
                }, _cache[12] || (_cache[12] = [
                  _createElementVNode("i", { class: "iconfont icon-jia-tianchong" }, null, -1),
                  _createElementVNode("p", null, "上传凭证", -1)
                ]))
              ]),
              _: 1
            }, 8, ["modelValue", "before-read", "readonly"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("p", {
        class: "sample",
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.viewExp && _ctx.viewExp(...args)))
      }, "查看正确示例"),
      _cache[15] || (_cache[15] = _createElementVNode("div", { class: "condition" }, [
        _createElementVNode("p", null, "转账凭证需包含："),
        _createElementVNode("p", null, "1.转出账号（付款方）：客户姓名和账户号码"),
        _createElementVNode("p", null, "2.转入账号（收款方）：金马证券账户和账户号码"),
        _createElementVNode("p", null, "3.包含交易参考编号/转账金额/币种")
      ], -1)),
      _createVNode(_component_van_action_sheet, {
        show: _ctx.fileActionState,
        "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.fileActionState) = $event)),
        actions: _ctx.actionsList,
        "cancel-text": "取消",
        "close-on-click-action": "",
        onSelect: _ctx.onFileSelect
      }, null, 8, ["show", "actions", "onSelect"])
    ]),
    _: 1
  }, 8, ["onHandleNext", "isDisabled", "form"]))
}